import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { toothacheArticle } from '../../data/blog/toothacheArticle';
export function ToothPainArticle() {
  return <BlogArticleTemplate article={toothacheArticle} data-id="element-806" data-mp="26c767omdcedx" />;
}